// Generated by TsRpcGenerator, do not modify manually
// @ts-nocheck
// noinspection JSUnusedGlobalSymbols, ES6UnusedImports

import { Observable } from "rxjs"
import { InitializedChannel } from "../api-types.ts"
import type { AppDate, AppDateTime, Nominal, Pair, Ref } from "../api-types.ts"
import { getInitial, getResult, getUpdates } from "../types.ts"

import { ApiService } from "../ApiService.ts"

import { AiAgentTask, AiAgentTaskSettings, Batch, BatchInfo, PR_Project, PR_Project2, PR_RepositoryInfo, ProjectCodingGuidelines, ProjectColorKey, ProjectKey, ProjectPermissions, ProjectSecret, ProjectSettings, ProjectTeamRole, RepositoryFetchStatus, RuntimeConfig, TD_MemberProfile, TID, URemoteRepositoryAuth } from "./TypeDefinitions.ts"

export interface Projects {
  addProjectSecret(projectKey: ProjectKey, secret: ProjectSecret, value: string): Promise<void>

  canCreateSampleProject(): Promise<boolean>

  createSampleProjectAndTask(settings: AiAgentTaskSettings | null): Promise<AiAgentTask>

  deleteProject(projectKey: ProjectKey): Promise<void>

  deleteProjectSecret(projectKey: ProjectKey, key: string): Promise<void>

  favoriteProjects(): Promise<ProjectKey[]>

  fetchRepository(projectKey: ProjectKey): Promise<void>

  getFetchStatus(projectKey: ProjectKey): Promise<RepositoryFetchStatus>

  getProject(projectKey: ProjectKey): Promise<PR_Project>

  getProjectCodingGuidelines(projectKey: ProjectKey, repository: string): Promise<ProjectCodingGuidelines | null>

  getProjectMembers(batchInfo: BatchInfo, projectKey: ProjectKey): Promise<Batch<Pair<TD_MemberProfile, boolean>>>

  getProjectPermissions(projectKey: ProjectKey): Promise<ProjectPermissions>

  getProjectRuntimeConfig(projectKey: ProjectKey, repository: string): Promise<Pair<RuntimeConfig, boolean> | null>

  /** @deprecated Preview pooling is now always enabled via configuration. This method is a no-op. */
  getProjectSettings(projectKey: ProjectKey): Promise<ProjectSettings>

  getProjectV2(projectKey: ProjectKey, numberOfTasks: number): Promise<PR_Project2>

  getRepositories(projectKey: ProjectKey): Promise<PR_RepositoryInfo[]>

  listProjectSecrets(projectKey: ProjectKey): Promise<ProjectSecret[]>

  listProjectsV2(batch: BatchInfo, numberOfTasks: number): Promise<Batch<PR_Project2>>

  removeProjectMember(projectKey: ProjectKey, username: string, role: ProjectTeamRole): Promise<void>

  setProjectMemberRole(projectKey: ProjectKey, username: string, role: ProjectTeamRole): Promise<void>

  setRepositoryAuth(projectKey: ProjectKey, repository: string, remoteUrl: string, auth: URemoteRepositoryAuth): Promise<void>

  startProjectCreation(url: string, settings: AiAgentTaskSettings | null): Promise<AiAgentTask>

  subscribeToRepositorySyncErrors(projectKey: ProjectKey, repository: string): Promise<InitializedChannel<RepositoryFetchStatus, RepositoryFetchStatus>>

  toggleFavoriteProject(projectKey: ProjectKey, favorite: boolean): Promise<void>

  updateProjectCodingGuidelines(projectKey: ProjectKey, repository: string, content: string): Promise<void>

  updateProjectColor(projectKey: ProjectKey, colorKey: ProjectColorKey | null): Promise<void>

  updateProjectCover(projectKey: ProjectKey, attachmentId: TID | null): Promise<void>

  updateProjectName(projectKey: ProjectKey, name: string): Promise<void>

  updateProjectRootFolder(projectKey: ProjectKey, repository: string, rootFolder: string): Promise<void>

  updateProjectSecret(projectKey: ProjectKey, key: string, description: string | null, value: string): Promise<void>

  /** @deprecated Preview pooling is now always enabled via configuration. This method is a no-op. */
  updateProjectSettings(projectKey: ProjectKey, settings: ProjectSettings): Promise<void>
}

export class ProjectsClient implements Projects {
  constructor(private service: ApiService) {}

  async addProjectSecret(projectKey: ProjectKey, secret: ProjectSecret, value: string): Promise<void> {
    return getResult(await this.service.rpc<void, never>("Projects/addProjectSecret", {
      projectKey: projectKey,
      secret: secret,
      value: value,
    }))
  }

  async canCreateSampleProject(): Promise<boolean> {
    return getResult(await this.service.rpc<boolean, never>("Projects/canCreateSampleProject", {
    }))
  }

  async createSampleProjectAndTask(settings: AiAgentTaskSettings | null): Promise<AiAgentTask> {
    return getResult(await this.service.rpc<AiAgentTask, never>("Projects/createSampleProjectAndTask", {
      settings: settings,
    }))
  }

  async deleteProject(projectKey: ProjectKey): Promise<void> {
    return getResult(await this.service.rpc<void, never>("Projects/deleteProject", {
      projectKey: projectKey,
    }))
  }

  async deleteProjectSecret(projectKey: ProjectKey, key: string): Promise<void> {
    return getResult(await this.service.rpc<void, never>("Projects/deleteProjectSecret", {
      projectKey: projectKey,
      key: key,
    }))
  }

  async favoriteProjects(): Promise<ProjectKey[]> {
    return getResult(await this.service.rpc<ProjectKey[], never>("Projects/favoriteProjects", {
    }))
  }

  async fetchRepository(projectKey: ProjectKey): Promise<void> {
    return getResult(await this.service.rpc<void, never>("Projects/fetchRepository", {
      projectKey: projectKey,
    }))
  }

  async getFetchStatus(projectKey: ProjectKey): Promise<RepositoryFetchStatus> {
    return getResult(await this.service.rpc<RepositoryFetchStatus, never>("Projects/getFetchStatus", {
      projectKey: projectKey,
    }))
  }

  async getProject(projectKey: ProjectKey): Promise<PR_Project> {
    return getResult(await this.service.rpc<PR_Project, never>("Projects/getProject", {
      projectKey: projectKey,
    }))
  }

  async getProjectCodingGuidelines(projectKey: ProjectKey, repository: string): Promise<ProjectCodingGuidelines | null> {
    return getResult(await this.service.rpc<ProjectCodingGuidelines | null, never>("Projects/getProjectCodingGuidelines", {
      projectKey: projectKey,
      repository: repository,
    }))
  }

  async getProjectMembers(batchInfo: BatchInfo, projectKey: ProjectKey): Promise<Batch<Pair<TD_MemberProfile, boolean>>> {
    return getResult(await this.service.rpc<Batch<Pair<TD_MemberProfile, boolean>>, never>("Projects/getProjectMembers", {
      batchInfo: batchInfo,
      projectKey: projectKey,
    }))
  }

  async getProjectPermissions(projectKey: ProjectKey): Promise<ProjectPermissions> {
    return getResult(await this.service.rpc<ProjectPermissions, never>("Projects/getProjectPermissions", {
      projectKey: projectKey,
    }))
  }

  async getProjectRuntimeConfig(projectKey: ProjectKey, repository: string): Promise<Pair<RuntimeConfig, boolean> | null> {
    return getResult(await this.service.rpc<Pair<RuntimeConfig, boolean> | null, never>("Projects/getProjectRuntimeConfig", {
      projectKey: projectKey,
      repository: repository,
    }))
  }

  /** @deprecated Preview pooling is now always enabled via configuration. This method is a no-op. */
  async getProjectSettings(projectKey: ProjectKey): Promise<ProjectSettings> {
    return getResult(await this.service.rpc<ProjectSettings, never>("Projects/getProjectSettings", {
      projectKey: projectKey,
    }))
  }

  async getProjectV2(projectKey: ProjectKey, numberOfTasks: number): Promise<PR_Project2> {
    return getResult(await this.service.rpc<PR_Project2, never>("Projects/getProjectV2", {
      projectKey: projectKey,
      numberOfTasks: numberOfTasks,
    }))
  }

  async getRepositories(projectKey: ProjectKey): Promise<PR_RepositoryInfo[]> {
    return getResult(await this.service.rpc<PR_RepositoryInfo[], never>("Projects/getRepositories", {
      projectKey: projectKey,
    }))
  }

  async listProjectSecrets(projectKey: ProjectKey): Promise<ProjectSecret[]> {
    return getResult(await this.service.rpc<ProjectSecret[], never>("Projects/listProjectSecrets", {
      projectKey: projectKey,
    }))
  }

  async listProjectsV2(batch: BatchInfo, numberOfTasks: number): Promise<Batch<PR_Project2>> {
    return getResult(await this.service.rpc<Batch<PR_Project2>, never>("Projects/listProjectsV2", {
      batch: batch,
      numberOfTasks: numberOfTasks,
    }))
  }

  async removeProjectMember(projectKey: ProjectKey, username: string, role: ProjectTeamRole): Promise<void> {
    return getResult(await this.service.rpc<void, never>("Projects/removeProjectMember", {
      projectKey: projectKey,
      username: username,
      role: role,
    }))
  }

  async setProjectMemberRole(projectKey: ProjectKey, username: string, role: ProjectTeamRole): Promise<void> {
    return getResult(await this.service.rpc<void, never>("Projects/setProjectMemberRole", {
      projectKey: projectKey,
      username: username,
      role: role,
    }))
  }

  async setRepositoryAuth(projectKey: ProjectKey, repository: string, remoteUrl: string, auth: URemoteRepositoryAuth): Promise<void> {
    return getResult(await this.service.rpc<void, never>("Projects/setRepositoryAuth", {
      projectKey: projectKey,
      repository: repository,
      remoteUrl: remoteUrl,
      auth: auth,
    }))
  }

  async startProjectCreation(url: string, settings: AiAgentTaskSettings | null): Promise<AiAgentTask> {
    return getResult(await this.service.rpc<AiAgentTask, never>("Projects/startProjectCreation", {
      url: url,
      settings: settings,
    }))
  }

  async subscribeToRepositorySyncErrors(projectKey: ProjectKey, repository: string): Promise<InitializedChannel<RepositoryFetchStatus, RepositoryFetchStatus>> {
    return getInitial(await this.service.rpc<RepositoryFetchStatus, RepositoryFetchStatus>("flux/Projects/subscribeToRepositorySyncErrors", {
      projectKey: projectKey,
      repository: repository,
    }))
  }

  async toggleFavoriteProject(projectKey: ProjectKey, favorite: boolean): Promise<void> {
    return getResult(await this.service.rpc<void, never>("Projects/toggleFavoriteProject", {
      projectKey: projectKey,
      favorite: favorite,
    }))
  }

  async updateProjectCodingGuidelines(projectKey: ProjectKey, repository: string, content: string): Promise<void> {
    return getResult(await this.service.rpc<void, never>("Projects/updateProjectCodingGuidelines", {
      projectKey: projectKey,
      repository: repository,
      content: content,
    }))
  }

  async updateProjectColor(projectKey: ProjectKey, colorKey: ProjectColorKey | null): Promise<void> {
    return getResult(await this.service.rpc<void, never>("Projects/updateProjectColor", {
      projectKey: projectKey,
      colorKey: colorKey,
    }))
  }

  async updateProjectCover(projectKey: ProjectKey, attachmentId: TID | null): Promise<void> {
    return getResult(await this.service.rpc<void, never>("Projects/updateProjectCover", {
      projectKey: projectKey,
      attachmentId: attachmentId,
    }))
  }

  async updateProjectName(projectKey: ProjectKey, name: string): Promise<void> {
    return getResult(await this.service.rpc<void, never>("Projects/updateProjectName", {
      projectKey: projectKey,
      name: name,
    }))
  }

  async updateProjectRootFolder(projectKey: ProjectKey, repository: string, rootFolder: string): Promise<void> {
    return getResult(await this.service.rpc<void, never>("Projects/updateProjectRootFolder", {
      projectKey: projectKey,
      repository: repository,
      rootFolder: rootFolder,
    }))
  }

  async updateProjectSecret(projectKey: ProjectKey, key: string, description: string | null, value: string): Promise<void> {
    return getResult(await this.service.rpc<void, never>("Projects/updateProjectSecret", {
      projectKey: projectKey,
      key: key,
      description: description,
      value: value,
    }))
  }

  /** @deprecated Preview pooling is now always enabled via configuration. This method is a no-op. */
  async updateProjectSettings(projectKey: ProjectKey, settings: ProjectSettings): Promise<void> {
    return getResult(await this.service.rpc<void, never>("Projects/updateProjectSettings", {
      projectKey: projectKey,
      settings: settings,
    }))
  }

}

